import React from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './authContext';

import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error('Root element not found!');
  document.body.innerHTML = '<div style="padding: 20px; background: red; color: white; font-size: 24px;">ERROR: Root element not found!</div>';
} else {
  console.log('Root element found, creating React root...');
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <ErrorBoundary>
      <BrowserRouter>
        <Provider store={store}>
          <AuthProvider>
            <App />
          </AuthProvider>
          <ToastContainer position="top-right" />
        </Provider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
